import { ref, watch } from 'vue'

import { getAdminDivisionsByPoint } from '@/services/adminDivisions'

interface Point {
  latitude?: number
  longitude?: number
}

export function useAdminDivisions(point: () => Point) {
  const level1 = ref<string | null>(null)
  const level2 = ref<string | null>(null)
  let lookup = 0

  watch(
    [() => point().latitude, () => point().longitude],
    async ([latitude, longitude]) => {
      const current = ++lookup
      level1.value = null
      level2.value = null
      if (latitude == null || longitude == null) return

      const divisions = await getAdminDivisionsByPoint(latitude, longitude)
      if (current !== lookup) return
      level1.value = divisions.level1
      level2.value = divisions.level2
    },
    { immediate: true }
  )

  return { level1, level2 }
}
